@if (!(headerService.hideHeader$ | async)){

<div class="header">
  <div class="headerTitle">
    <h1>
      <span>{{ title }}</span>
    </h1>
    <div class="headerImageContainer">
      <img class="imageLogo" src="/images/krugerveolia.png" />
    </div>

    @if (currentUser) {
    <div #userContainer class="userContainer">
      <img referrerpolicy="no-referrer" (click)="toggleShowUserOptions()" [src]="this.profilePicture"
        class="userLogo" />
      <div [ngClass]="{ showUserOptions: showUserOptions }" class="userInfoContainer">
        <div class="topUserInfo"></div>
        <div class="userInfoLogoContainer">
          <img referrerpolicy="no-referrer" [src]="this.profilePicture" class="userInfoLogo" />
        </div>
        <div class="bottomUserInfo">
          <span class="fullName">{{ currentUser.name }}</span>
          <span>{{ currentUser.email }}</span>
          <button mat-flat-button color="accent" (click)="signOut()" class="signOutButton">
            Sign out
          </button>
          @if ( getCorrectRoleBasedOnUrl(currentUser) ==
          getEnumUserRoleTypes.Admin && this.currentSite == 'kursus' ) {
          <div class="chooseViewRole">
            <div class="chooseViewRoleContainer">
              <p>Aktiv rolle</p>
              <select [(ngModel)]="userRoleType" (change)="changeActiveRole()" class="roleSelect">
                @for (role of viewRoles; track role) {
                <option [value]="role.value">
                  {{ role.name }}
                </option>
                }
              </select>
            </div>
          </div>
          }
          <h2 class="heading main">Mine oplysninger</h2>
          <div class="userDetails">
            @if (currentUser.name) {
            <div class="detailRow">
              <div class="detailLabel">Fulde Navn</div>
              <div class="detailValue">{{ currentUser.name }}</div>
            </div>
            } @if (currentUser.initials) {
            <div class="detailRow">
              <div class="detailLabel">Initialer</div>
              <div class="detailValue">
                {{ currentUser.initials }}
              </div>
            </div>
            } @if (currentUser.employeeNumber) {
            <div class="detailRow">
              <div class="detailLabel">Medarbejder nr.</div>
              <div class="detailValue">{{ currentUser.employeeNumber }}</div>
            </div>
            } @if (currentUser.email) {
            <div class="detailRow">
              <div class="detailLabel">Email</div>
              <div class="detailValue emailValue">{{ currentUser.email }}</div>
            </div>
            } @if (currentUser.nearestManager?.name) {
            <div class="detailRow">
              <div class="detailLabel">Nærmeste leder</div>
              <div class="detailValue">
                {{ currentUser.nearestManager!.name }}
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    } @if (currentUser && this.listOfUsersSites.length >= 2) {
    <div #changeSiteContainer class="changeSiteContainer">
      <img class="imageDots" src="/images/appsIcon.svg" (click)="changeSiteMenu()" />
      <div [ngClass]="{ showChangeSite: showChangeSite }" class="changeSite">
        <div class="changeSiteContent">
          <div class="changeSiteBody">
            @for (site of listOfUsersSites; track site) {
            <div class="site" (click)="changeSite(site)">
              <span [class.active]="
                  site.toLowerCase() === currentSite.toLowerCase()
                ">{{ site }}</span>
            </div>
            }
          </div>
          <div></div>
        </div>
      </div>
    </div>
    }
  </div>
</div>

}